import { CHANNEL_LAYOUT_VALUES } from './constants/channel-layout-values';
import { CHANNEL_VIDEO_LIST_VALUES } from './constants/channel-video-list-values';
import { COMPACT_PLAY_TYPE_VALUES } from './constants/compact-play-type';
import { COMPACT_SHOW_VIDEO_LIST_VALUES } from './constants/compact-show-video-list';
import { INFO_POSITION_VALUES } from './constants/info-position-values';
import { LAYOUT_STYLE_VALUES } from './constants/layout-style-values';
import { MAIN_ACTION_STYLE_TYPES } from './constants/main-action-style-types';
import { MAIN_ITEM_TYPE_VALUES } from './constants/main-item-type-values';
import { SHOW_INFO_VALUES } from './constants/show-info-values';
import { SHOW_MEDIA_TYPE_VALUES } from './constants/show-media-type-values';
import { TITLE_POSITION_VALUES } from './constants/title-position-values';
import { APP_SETTINGS_VERSION_LATEST } from './constants/versions';

/* Change default settings here to modify defaults for new installations.
 * Existing installations will not be affected with these changes */

const defaultSettings = {
  booleans: {
    enableVideosSharing: true,
    showChannelCategories: false,
    showChannelShare: true,
    showChannelTitle: true,
    showChannelInfo: false,
    showSearch: true,
    showSignIn: false,
    showChannelTags: true,
    showChannelVideos: true,
    showFullInfo: true,
    showVideoPublisherInList: true,
    showVideoTitleInList: true,
    showTitleForMainItem: true,
    showPublisherForMainItem: true,
    showActionBar: true,
  },
  numbers: {
    videoInfoPosition: INFO_POSITION_VALUES.ON_VIDEOS,
    showInfoAction: SHOW_INFO_VALUES.ON_MOUSE_OVER,
    layoutStyle: LAYOUT_STYLE_VALUES.SQUARE,
    channelLayout: CHANNEL_LAYOUT_VALUES.CLASSIC,
    mainItemType: MAIN_ITEM_TYPE_VALUES.CHANNEL_COVER,
    mainItemTitlePosition: TITLE_POSITION_VALUES.CENTER,
    videoListVisibility: CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
    videosInRow: 4,
    mainItemOverlayOpacity: 35,
    showMediaType: SHOW_MEDIA_TYPE_VALUES.COVER_IMAGE,
    numberOfRows: 1,
    playType: COMPACT_PLAY_TYPE_VALUES.IN_FRAME,
    compactShowVideoListType: COMPACT_SHOW_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
    mainActionStyleType: MAIN_ACTION_STYLE_TYPES.ICON_WITH_TEXT,
    settingsVersion: APP_SETTINGS_VERSION_LATEST,
  },
  colors: {
    compactMenuActionsColor: {
      themeName: 'color-1',
      value: 'rgba(255,255,255,1)'
    },
    compactMenuBackgroundColor: {
      themeName: 'color-5',
      value: 'rgba(65,65,65,1)'
    },
  },
  editMode: 'site',
};

export default defaultSettings;



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/default-settings.js